const isBuiltinModel = (modelId: string = '') => !modelId.startsWith('ft:');

export default isBuiltinModel;
